<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M13.5 22.5L11.5 22.1L12.3 17.8L8.7 15.1L7.4 9.40001L5.2 11.3L6 15.1L4 15.5L3 10.6L7.45 6.62501C7.83333 6.29167 8.28767 6.15434 8.813 6.21301C9.33833 6.27167 9.84233 6.40067 10.325 6.60001C10.8583 6.83334 11.4127 7.00001 11.988 7.10001C12.5633 7.20001 13.1423 7.20834 13.725 7.12501C14.3077 7.04167 14.8453 6.85001 15.338 6.55001C15.8307 6.25001 16.3013 5.91667 16.75 5.55001L18 7.10001C17.5 7.48334 16.9833 7.84167 16.45 8.17501C15.9167 8.50834 15.3417 8.76667 14.725 8.95001C14.175 9.10001 13.621 9.17934 13.063 9.18801C12.505 9.19667 11.9507 9.13401 11.4 9.00001L12.1 12.1L15.8 11.4L21 15.1L19.8 16.7L15.5 13.7L11.9 14.4L14.6 16.4L13.5 22.5ZM8 5.50001C7.45 5.50001 6.97933 5.30434 6.588 4.91301C6.19667 4.52167 6.00067 4.05067 6 3.50001C5.99933 2.94934 6.19533 2.47867 6.588 2.08801C6.98067 1.69734 7.45133 1.50134 8 1.50001C8.54867 1.49867 9.01967 1.69467 9.413 2.08801C9.80633 2.48134 10.002 2.95201 10 3.50001C9.998 4.04801 9.80233 4.51901 9.413 4.91301C9.02367 5.30701 8.55267 5.50267 8 5.50001Z"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
